import React, { useCallback, useEffect, useRef } from 'react';
import './stylesGallery.scss';

const GalleryItem = ({ i, currImage, onImageSelected, isActive, onActivate, onDeactivate, onMouseLeave }) => {

  // Keep a ref that is always current — avoids stale closure in onClick
  const isActiveRef = useRef(isActive);
  useEffect(() => {
    isActiveRef.current = isActive;
  }, [isActive]);

  const handleClick = useCallback(() => {
    if (isActiveRef.current) {
      onDeactivate();
      onImageSelected(i);
    } else {
      onActivate(i);
    }
  }, [i, onActivate, onDeactivate, onImageSelected]);

  const handleMouseEnter = useCallback(() => {
    onActivate(i);
  }, [i, onActivate]);

  const baseClass = currImage.rollOver ? 'gallery--image-black' : 'gallery--image';
  const className = `${baseClass}${isActive ? ' hovered' : ''}`;

  return (
    <button
      className={className}
      style={{ left: currImage.left, top: currImage.top }}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <img src={process.env.PUBLIC_URL + currImage.src} alt={currImage.title} />

      {isActive && currImage.rollOver && (
        <div className="gallery--caption">
          <h1>{currImage.rollOver}</h1>
        </div>
      )}
    </button>
  );
};

export default GalleryItem;
